import { render, staticRenderFns } from "./RegularSettingsProfile.vue?vue&type=template&id=1f81cadc&"
import script from "./RegularSettingsProfile.vue?vue&type=script&lang=js&"
export * from "./RegularSettingsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports